var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"lg":"8","md":"6"}},[_c('classmate-list')],1),_c('b-col',{attrs:{"lg":"4","md":"6"}},[_c('course-detail')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }